import { Modal, Backdrop, Fade, Box } from "@mui/material";
import React from "react";
import "./commonmodal.scss";

function CommonModal({ open, onClose, children, className }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 200,
        },
      }}
      className="common-modal-wrapper"
    >
      <Fade in={open}>
        <Box className={className + " common-modal-box"}>{children}</Box>
      </Fade>
    </Modal>
  );
}

export default CommonModal;
